import React from 'react';
import { render } from 'react-dom';

import SupportPage from './supportpage.jsx';

const container = document.getElementById('support-app-js');

render(
  <React.StrictMode>
    <SupportPage options={container.dataset} />
  </React.StrictMode>,
  container
);
